import React, { useEffect, useState } from "react";
import simpleImg from "../../../../assets/images/image-right.svg";
import baseImg from "../../../../assets/images/image-left.svg";
import Image from "../../Image";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { organizationAddEdit } from "../../../../services/organizationService";
import { toast } from "react-toastify";
import useForm from "../../../../hooks/useForm";
import Form from "../../../form/Form";
import Button from "../../../form/Button";
import { useTranslation } from "react-i18next";

const detailsoption = [
  { key: "simple", label: "Side by side", image: simpleImg },
  { key: "reverse", label: "Side by side reverse", image: baseImg },
];

const EventOrganisationContent = ({
  data = {},
  organizationDetailsRefetch,
  selectedLang,
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({
      initialState: {
        detailsBannerLayout: "simple",
      },
    });

  useEffect(() => {
    setFieldsValue({
      detailsBannerLayout: data?.eventSetting?.detailsBannerLayout || "simple",
    });
  }, [data?.eventSetting]);

  const { mutate: saveEventTheme, isPending } = useMutation({
    mutationFn: async (value) => {
      const res = await organizationAddEdit({
        ...(data?._id && { id: data?._id }),
        eventSetting: {
          ...value,
        },
      });
      return res;
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        organizationDetailsRefetch();

        toast.success(res?.message);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
  });

  return (
    <Form onSubmit={saveEventTheme} handleSubmit={handleSubmit}>
      <div className="relative divide-y divide-slate-200 space-y-5">
        <div className="py-4 md:py-8 px-3 md:px-6 rounded-md space-y-4 border border-gray-200">
          <div className="relative py-3">
            <h2 className="text-xl font-bold text-deep-purple mb-2 font-Montserrat">
              {t("Event Details")}
            </h2>
            <p className="mb-6 text-sm text-text-secondary font-[300]">
              {t("Customise the details on each event page")}
            </p>
            <div className="flex flex-wrap gap-4 mb-3">
              {detailsoption.map((item) => (
                <label
                  key={item.key}
                  className={`rounded-xl overflow-hidden cursor-pointer border-2 transition-all ${
                    values?.detailsBannerLayout === item.key
                      ? "border-primary"
                      : "border-gray-300"
                  }`}
                >
                  <input
                    type="radio"
                    name="theme"
                    value={item.key}
                    checked={values?.detailsBannerLayout === item.key}
                    onChange={() =>
                      handleChange({
                        target: {
                          name: "detailsBannerLayout",
                          value: item.key,
                        },
                      })
                    }
                    className="hidden"
                  />

                  <div className="w-60 aspect-square overflow-hidden">
                    <Image
                      src={item.image}
                      alt={item.label}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="px-4 py-3 border-t text-center bg-gray-50">
                    <h4 className="text-base font-semibold text-primary capitalize">
                      {t(item.label)}
                    </h4>
                  </div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-7 gap-3 justify-end bg-magnolia py-4 sticky bottom-0 right-0 z-[2] pr-4 md:pr-6">
        <Button
          buttonType="submit"
          buttonLabel={"Publish changes"}
          {...(isPending && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </Form>
  );
};

export default EventOrganisationContent;
